export default "__VITE_ASSET__Besto1Gi__"